module.exports = __webpack_public_path__ + "audio-16fe29dd2011.m4a";